import { T } from '@territory/tokens';
import { space } from '../scale.js';

/* The native chapter control has an off-scale 10px gap. Font and normal radius stay omitted. */
const CHAPTER_GAP = 10;
export function marketingChapterCss(sel: string): string {
  return `${sel} { display: flex; align-items: center; justify-content: flex-end; gap: ${CHAPTER_GAP}px; height: ${space[6]}px; padding: 0; background: none; border: none; cursor: pointer; }
${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 3px; border-radius: ${space[1]}px; }`;
}
